import React from 'react'
import './style.scss'
import { Autoplay, FreeMode, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';

export default function Footer({ isVisible }) {

    return (
        <div className="landing-footer">
            <div className="landing-container">

                <div className="landing-footer-slider">
                    <Swiper
                        spaceBetween={0}
                        slidesPerView={'auto'}
                        allowTouchMove={false}
                        speed={10000}
                        loop={true}
                        autoplay={{
                            delay: 0,
                            disableOnInteraction: false,
                        }}
                        freeMode={true}
                        modules={[Autoplay, FreeMode]}

                    >

                        <SwiperSlide style={{ width: isVisible ? '756rem' : '504rem' }}>
                            <div className="landing-footer-slider-wrapper">
                                <img style={{ width: isVisible ? '153rem' : '102rem' }} src={`${process.env.REACT_APP_BASENAME}/img/f1.svg`} alt="" />
                                <img style={{ width: isVisible ? '153rem' : '102rem' }} src={`${process.env.REACT_APP_BASENAME}/img/f2.svg`} alt="" />
                                <img style={{ width: isVisible ? '125rem' : '83rem' }} src={`${process.env.REACT_APP_BASENAME}/img/f3.svg`} alt="" />
                                <img style={{ width: isVisible ? '66rem' : '44rem' }} src={`${process.env.REACT_APP_BASENAME}/img/f4.svg`} alt="" />
                                <img style={{ width: isVisible ? '139rem' : '93rem' }} src={`${process.env.REACT_APP_BASENAME}/img/f5.svg`} alt="" />
                            </div>

                        </SwiperSlide>
                        <SwiperSlide style={{ width: isVisible ? '746rem' : '504rem' }}>
                            <div className="landing-footer-slider-wrapper">
                                <img style={{ width: isVisible ? '153rem' : '102rem' }} src={`${process.env.REACT_APP_BASENAME}/img/f1.svg`} alt="" />
                                <img style={{ width: isVisible ? '153rem' : '102rem' }} src={`${process.env.REACT_APP_BASENAME}/img/f2.svg`} alt="" />
                                <img style={{ width: isVisible ? '125rem' : '83rem' }} src={`${process.env.REACT_APP_BASENAME}/img/f3.svg`} alt="" />
                                <img style={{ width: isVisible ? '66rem' : '44rem' }} src={`${process.env.REACT_APP_BASENAME}/img/f4.svg`} alt="" />
                                <img style={{ width: isVisible ? '139rem' : '93rem' }} src={`${process.env.REACT_APP_BASENAME}/img/f5.svg`} alt="" />
                            </div>

                        </SwiperSlide>



                    </Swiper>
                </div>
                <div className="landing-footer-left">
                    <div className="landing-footer-left-text">
                        <p>Zeely, Inc. 2810 N Church St, Ste 27833,<br></br>
                            Wilmington, DE 19802-4447</p>
                        <p>2025 © All rights reserved</p>
                    </div>
                </div>
                <div className="landing-footer-right">
                    <ul>
                        <li>
                            <div onClick={(e) => {
                                e.stopPropagation(); window.open("https://zeely.ai/privacy-policy/", "_blank")
                            }} >Privacy Policy</div>
                        </li>
                        <li>
                            <div onClick={(e) => {
                                e.stopPropagation(); window.open("https://zeely.ai/terms-of-service/", "_blank")
                            }} >Terms of use</div>
                        </li>
                        <li>
                            <div onClick={(e) => {
                                e.stopPropagation(); window.open("https://zeely.ai/legal/", "_blank")
                            }} >Legal Center</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
